module.exports = __webpack_public_path__ + "images/favicon-wave.ico";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/favicon-wave.ico
// module id = 6JEJ
// module chunks = 151